"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAvatarSizes = exports.getAvatarShapes = void 0;
var getAvatarSizes = function getAvatarSizes(theme) {
  return {
    small: {
      width: 33,
      height: 33,
      minWidth: 33,
      minHeight: 33
    },
    medium: {
      width: 55,
      height: 55,
      minWidth: 55,
      minHeight: 55
    },
    large: {
      width: 77,
      height: 77,
      minWidth: 77,
      minHeight: 77
    },
    xlarge: {
      width: 100,
      height: 100,
      minHeight: 100,
      minWidth: 100
    }
  };
};
exports.getAvatarSizes = getAvatarSizes;
var getAvatarShapes = function getAvatarShapes(theme) {
  var avatarShapes = theme.avatarShapes;
  return {
    circle: {
      borderRadius: '50%'
    },
    square: {
      borderRadius: '10px'
    }
  };
};
exports.getAvatarShapes = getAvatarShapes;